import { CalendarTaskState } from "../enums";
import { ModifyUser } from "../user/modifyUser";
var CalendarTaskItem = /** @class */ (function () {
    function CalendarTaskItem(obj) {
        this.id = obj && obj.id || "";
        this.parentId = obj === null || obj === void 0 ? void 0 : obj.parentId;
        this.companyId = obj && obj.companyId || "";
        this.recordId = obj === null || obj === void 0 ? void 0 : obj.recordId;
        this.startDate = obj && obj.startDate || 0;
        this.endDate = obj === null || obj === void 0 ? void 0 : obj.endDate;
        this.allDay = obj && obj.allDay || false;
        this.title = obj && obj.title || "";
        this.state = obj && obj.state || CalendarTaskState.NotStarted;
        this.isPrivate = obj && obj.isPrivate || false;
        this.databaseRecordType = obj === null || obj === void 0 ? void 0 : obj.databaseRecordType;
        this.locationText = obj && obj.locationText || "";
        this.description = obj && obj.description || "";
        this.categoryId = obj && obj.categoryId || "";
        this.categoryCode = obj && obj.categoryCode || "";
        this.categoryColor = obj && obj.categoryColor || "";
        this.createUser = new ModifyUser(obj ? obj.createUser : null);
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
    return CalendarTaskItem;
}());
export { CalendarTaskItem };
